import { render, staticRenderFns } from "./edit_and_add_staff_info.vue?vue&type=template&id=47b2c7d0&scoped=true&"
import script from "./edit_and_add_staff_info.vue?vue&type=script&lang=tsx&"
export * from "./edit_and_add_staff_info.vue?vue&type=script&lang=tsx&"
import style0 from "./edit_and_add_staff_info.vue?vue&type=style&index=0&id=47b2c7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2c7d0",
  null
  
)

export default component.exports